module.exports = __webpack_public_path__ + "img/Plantas rebaixadas e com retirada de ramos laterais 3.1f796c47.webp";